(function () {
  'use strict';

  // menu su telefono
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('[data-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  // quantita'
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += b.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(1, v);
  });

  // caroselli
  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 20 : 300;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max || max <= 0;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step() * 2; });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step() * 2; });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  // slider della testata
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-dot]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); restart(); });
    });
    function restart() {
      if (reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, 6000);
    }
    show(0); restart();
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
  });

  // galleria della scheda prodotto
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.full || t.querySelector('img').src;
        main.srcset = '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // ordinamento della collezione
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
})();
